module.exports = __webpack_public_path__ + "media/images/icon_crown-55b9f16ce1473c2d5c6549b91d7b3361.svg";